import styled from 'styled-components';

import { Spinner } from '@frontend/components';

const Wrapper = styled.div`
  align-items: center;
  background: transparent;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  position: absolute;
  width: 100%;
  z-index: 3;
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: 500;
  margin: 10px;
`;

const FetchingInfoScreen = () => (
  <Wrapper>
    <Title>Fetching Tech Data</Title>
    <Spinner size="lg" />
  </Wrapper>
);

export default FetchingInfoScreen;
